import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonMaterialModule } from '@nrwl/common-material';
import { CommonLibModule } from '@nrwl/common-lib';

import { CodecChoiceComponent } from './codec.choice/codec.choice.component';
import { CodecChoiceService } from './codec.choice/codec.choice.service';
import { IPChoiceComponent } from './ip.choice/ip.choice.component';
import { LocationSettingsComponent } from './location.settings/location.settings.component';
import { NetworkSettingsComponent } from './network.settings/network.settings.component';
import { NotificationPrefsComponent } from './notification.prefs/notification.prefs.component';
import { NtpSettingsComponent } from './ntp.settings/ntp.settings.component';
import { PlatformChoiceComponent } from './platform.choice/platform.choice.component';
import { ProxySettingsComponent } from './proxy.settings/proxy.settings.component';
import { SIPProxySettingsComponent } from './sip.proxy.settings/sip.proxy.settings.component';
import { ThresholdComponent } from './threshold/threshold.component';
import { NetworkSettingsService } from './network.settings/network.settings.service';
import { PlatformChoiceService } from './platform.choice/platform.choice.service';
import { DnsValidatorDirective } from './network.settings/dns.validator.directive';
import { ValidAliasDirective } from '../../wizard/directives/valid.alias.directive';
import { ClaimCodeValidator } from './claim.code/claim.code.validator';
import { CaptureOutputDirective } from '../../wizard/directives/capture.output.directive';
import { ClaimCodeComponent } from './claim.code/claim.code.component';
import { ClaimCodeFormatter } from './claim.code/claim.code.formatter';

import { SubnetSettingsComponent } from './subnet.settings/subnet.settings.component';
import { DatasourceListComponent } from './datasource.list/datasource.list.component';

@NgModule({
  imports: [CommonModule, CommonMaterialModule, FormsModule, ReactiveFormsModule, CommonLibModule],
  declarations: [
    CodecChoiceComponent,
    IPChoiceComponent,
    LocationSettingsComponent,
    NetworkSettingsComponent,
    NotificationPrefsComponent,
    NtpSettingsComponent,
    PlatformChoiceComponent,
    ProxySettingsComponent,
    SIPProxySettingsComponent,
    ThresholdComponent,
    DnsValidatorDirective,
    ValidAliasDirective,
    ClaimCodeValidator,
    ClaimCodeFormatter,
    ClaimCodeComponent,
    CaptureOutputDirective,
    SubnetSettingsComponent,
    DatasourceListComponent
  ],
  exports: [
    CodecChoiceComponent,
    IPChoiceComponent,
    LocationSettingsComponent,
    NetworkSettingsComponent,
    NotificationPrefsComponent,
    NtpSettingsComponent,
    PlatformChoiceComponent,
    ProxySettingsComponent,
    SIPProxySettingsComponent,
    ThresholdComponent,
    ValidAliasDirective,
    ClaimCodeComponent,
    CaptureOutputDirective,
    SubnetSettingsComponent,
    DatasourceListComponent
  ],
  providers: [CodecChoiceService, NetworkSettingsService, PlatformChoiceService]
})
export class WizardControlsModule {}
